// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../demo/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-content .decoration-ep-variable {\n  background-color: #e4f7ff;\n}\n", ""]);
// Exports
module.exports = exports;
